export default __webpack_public_path__ + "static/media/testifyTwo.fd5b5543.png";